enum DocumentEventType {
    Add = "add",
    Remove = "remove",
    RemoveAll = "removeAll",
    ContentsChanged = "contentsChanged",
}

export default DocumentEventType;
